export class DeleteMicrosoftCalendarEntriesForMoovStepInstanceRequest{
    public requestorId!:number;
    public moovStepInstanceId!:number;
    public requestorCustomerId!:number;
    public clientId!:number;
}
